import React from 'react';

class ThingsOrder extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default ThingsOrder;


// WEBPACK FOOTER //
// ./src/routes/thingsOrder/index.js